import { useState, useEffect } from "react";
import {
  Typography,
  Box,
  IconButton,
  Button,
  DialogContent,
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContentText,
  TextField,
  Grid,
  Tooltip,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseInstallmentTerminals } from "./UseInstallmentTerminals";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import EditIcon from "@mui/icons-material/Edit";

export default function InstallmentTerminals() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { getInstallmentTerminals, UpdateInstallmentTerminals } =
    UseInstallmentTerminals();

  const [openUpdateDialog, setOpenUpdateDialog] = useState(false);

  const [openDialog, setOpenDialog] = useState({
    show: false,
    model: undefined,
  });

  const [pageState, setPageState] = useState({
    page: 1,
  });

  const [installmentRes, setInstallmentRes] = useState();
  const [updateState, setUpdateState] = useState({
    username: "",
    password: "",
    token: "",
    terminalUrl: null,
    description: "",
  });

  useEffect(() => {
    setProgress(true);
    getInstallmentTerminals((Installments) => {
      setInstallmentRes(Installments);
    }, true);
  }, []);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "index",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "companyName",
      headerName: "نام درگاه",
      width: 200,
      align: "center",
      sortable: false,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="body2" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.companyName}
          </Typography>
        );
      },
    },
    {
      field: "enable",
      headerName: "وضعیت",
      width: 90,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.enable ? (
              <CheckIcon style={{ color: "#618833" }} />
            ) : (
              <CloseOutlinedIcon style={{ color: "red" }} />
            )}
          </Box>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 200,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="ویرایش">
              <IconButton
                onClick={() => {
                  setOpenUpdateDialog(true);
                  setUpdateState(cellValues.row);
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <IconButton
              sx={{ p: 0.5, mr: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  index: cellValues.row.index - 1,
                  enable: cellValues.row.enable,
                };
                if (cellValues.row.index - 1 == 0) {
                  return;
                } else {
                  setProgress(true);
                  UpdateInstallmentTerminals(model, () => {
                    getInstallmentTerminals((Installments) => {
                      setInstallmentRes(Installments);
                    }, false);
                  });
                }
              }}
            >
              <ArrowDropUpIcon fontSize="small" sx={{}} />
            </IconButton>
            <IconButton
              sx={{ p: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  index: cellValues.row.index + 1,
                  enable: cellValues.row.enable,
                };

                if (cellValues.row.index + 1 == installmentRes.length + 1) {
                  return;
                } else {
                  setProgress(true);
                  UpdateInstallmentTerminals(model, () => {
                    getInstallmentTerminals((Installments) => {
                      setInstallmentRes(Installments);
                    }, false);
                  });
                }
              }}
            >
              <ArrowDropDownIcon fontSize="small" sx={{}} />
            </IconButton>
            <Box sx={{ ml: 1 }}>
              {cellValues.row.enable ? (
                <Button
                  onClick={() => {
                    setOpenDialog({
                      show: true,
                      model: {
                        id: cellValues.row.id,
                        bankName: cellValues.row.bankName,
                        enable: false,
                        index: cellValues.row.index,
                      },
                    });
                  }}
                  variant="contained"
                  color="error"
                >
                  غیرفعال
                </Button>
              ) : (
                <Button
                  onClick={() => {
                    setOpenDialog({
                      show: true,
                      model: {
                        id: cellValues.row.id,
                        bankName: cellValues.row.bankName,
                        enable: true,
                        index: cellValues.row.index,
                      },
                    });
                  }}
                  variant="contained"
                >
                  فعال
                </Button>
              )}
            </Box>
          </>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "سفارشات",
        childs: [
          {
            name: msActiveMenu.pageTitle,
            url: "/installmentterminals",
          },
        ],
      }}
    >
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        open={openDialog.show}
        onClose={() => setOpenDialog({ ...openDialog, show: false })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle color="red" id="alert-dialog-title">
          توجه!
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            آیا از{" "}
            {openDialog.show && !openDialog.model.enable ? "غیرفعال" : "فعال"}{" "}
            کردن درگاه اطمینان دارید ؟
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ color: "#565656 !important" }}
            onClick={() => {
              UpdateInstallmentTerminals(openDialog.model, () => {
                getInstallmentTerminals((Installments) => {
                  setOpenDialog({ ...openDialog, show: false });
                  setInstallmentRes(Installments);
                }, false);
              });
            }}
          >
            بله
          </Button>
          <Button
            color="secondary"
            onClick={() => setOpenDialog({ ...openDialog, show: false })}
          >
            خیر
          </Button>
        </DialogActions>
      </Dialog>
      {installmentRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          rows={installmentRes ? installmentRes : []}
          page={pageState.page - 1}
          pageSize={20}
          Pagination
          onPageChange={(newPage) => {
            setPageState((old) => ({ ...pageState, page: newPage + 1 }));
          }}
          rowCount={installmentRes.length ? installmentRes.length : "1"}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              nofab: true,
              isLtr: true,
              // nofab: true,
              rowCount:
                installmentRes && installmentRes.length
                  ? installmentRes.length
                  : "",
            },
          }}
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        maxWidth="sm"
        open={openUpdateDialog}
        onClose={() => setOpenUpdateDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            <Typography
              sx={{
                color: "primary.main",
              }}
            >
              ویرایش درگاه
            </Typography>
            <TextField
              value={updateState.username ? updateState.username : ""}
              label="نام کاربری"
              fullWidth
              onChange={(evt) => {
                setUpdateState({
                  ...updateState,
                  username: evt.target.value,
                });
              }}
              sx={{ input: { direction: "rtl" } }}
              variant="outlined"
            />

            <TextField
              value={updateState.password ? updateState.password : ""}
              label="رمز عبور"
              fullWidth
              onChange={(evt) => {
                setUpdateState({
                  ...updateState,
                  password: evt.target.value,
                });
              }}
              sx={{ input: { direction: "rtl" } }}
              variant="outlined"
            />

            <TextField
              value={updateState.terminalUrl ? updateState.terminalUrl : ""}
              label="آدرس درگاه"
              fullWidth
              onChange={(evt) => {
                setUpdateState({
                  ...updateState,
                  terminalUrl: evt.target.value,
                });
              }}
              sx={{ input: { direction: "rtl" } }}
              variant="outlined"
            />
            <TextField
              value={updateState.token ? updateState.token : ""}
              label="توکن"
              fullWidth
              onChange={(evt) => {
                setUpdateState({
                  ...updateState,
                  token: evt.target.value,
                });
              }}
              multiline
              maxRows={6}
              sx={{ textarea: { direction: "rtl" } }}
              variant="outlined"
            />
            <TextField
              value={updateState.description ? updateState.description : ""}
              label="توضیحات"
              fullWidth
              onChange={(evt) => {
                setUpdateState({
                  ...updateState,
                  description: evt.target.value,
                });
              }}
              multiline
              rows={2}
              variant="outlined"
            />

            <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
              <Button
                sx={{ width: "90px" }}
                onClick={() => {
                  setProgress(true);
                  UpdateInstallmentTerminals(updateState, () => {
                    setOpenUpdateDialog(false);
                    getInstallmentTerminals((Installments) => {
                      setInstallmentRes(Installments);
                    }, false);
                  });
                }}
                variant="contained"
                color="secondary"
              >
                ثبت
              </Button>
              <Button
                sx={{ width: "90px" }}
                onClick={() => setOpenUpdateDialog(false)}
                variant="outlined"
              >
                بستن
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </Detail>
  );
}
